/** Clés localStorage utilisées pour les informations device (enregistrées au login). */
const DEVICE_STORAGE_KEYS = {
  DEVICE_ID: "device_id",
  DEVICE_NAME: "device_name",
  PLATFORM: "platform",
  IP: "ip",
} as const;

/** UUID stable par navigateur (`x-device-id` / NotificationDevices.deviceId). */
export function getDeviceId(): string {
  return getOrCreateDeviceId();
}

/** Génère un UUID v4 pour fallback device-id si non encore enregistré (ex: avant login). */
function getOrCreateDeviceId(): string {
  let id = localStorage.getItem(DEVICE_STORAGE_KEYS.DEVICE_ID);
  if (!id?.trim()) {
    id =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem(DEVICE_STORAGE_KEYS.DEVICE_ID, id);
  }
  return id;
}

/**
 * Retourne les headers device/app attendus par le backend.
 * x-device-id est toujours renseigné (fallback UUID si pas encore set au login).
 */
export const getDeviceHeaders = (): Record<string, string> => ({
  "x-device-id": getOrCreateDeviceId(),
  "x-device-name": localStorage.getItem(DEVICE_STORAGE_KEYS.DEVICE_NAME) || "",
  "x-platform": localStorage.getItem(DEVICE_STORAGE_KEYS.PLATFORM) || "",
  "x-device-ip": localStorage.getItem(DEVICE_STORAGE_KEYS.IP) || "",
  "x-app-version": import.meta.env.VITE_APP_VERSION || "",
  "x-language": navigator.language || "",
});
